/**
 * 模板皮肤管理接口
 * http://playable.dev.com:8067/?doc=gmaker/api%2fgmaker%2ftemplate_skin.go#-gmaker-template-skin-list
 */
import { AxiosPromise } from 'axios'
import { v2Host } from '@/config/host'
import request from '@/utils/request'

export function getTemplateSkinList(params: {
  template_id: number, // 模板id
  page?: number,
  page_size?: number,
  order?: 'id' | 'name'
}): AxiosPromise {
  return request({
    url: `${v2Host}/gmaker/template-skin/list`,
    method: 'get',
    params
  })
}

export function createTemplateSkin(data: {
  template_id: number, // 模板id
  name: string // 皮肤名称
}): AxiosPromise {
  return request({
    url: `${v2Host}/gmaker/template-skin/create`,
    method: 'post',
    data
  })
}

export function updateTemplateSkin(data: {
  id: number, // 皮肤id
  name: string // 皮肤名称
}): AxiosPromise {
  return request({
    url: `${v2Host}/gmaker/template-skin/update`,
    method: 'post',
    data
  })
}

export function deleteTemplateSkin(data: {
  id: number // 皮肤id
}): AxiosPromise {
  return request({
    url: `${v2Host}/gmaker/template-skin/delete`,
    method: 'post',
    data
  })
}
